<template>
  <div class="banner-container">
    <div class="banner-wrapper" ref="bannerWrapper">
      <div 
        class="banner-track" 
        :style="{ transform: `translateX(-${currentIndex * 100}%)` }"
      >
        <div 
          v-for="(item, index) in bannerList" 
          :key="index" 
          class="banner-slide"
          :style="{ background: item.gradient }"
          @click="goTo(item)"
        >
          <img :src="item.image" class="slide-image" :alt="'banner ' + (index + 1)" />
        </div>
      </div>
    </div>
    
    <!-- 分页指示器 -->
    <div class="banner-pagination">
      <span 
        v-for="(_, index) in bannerList" 
        :key="index" 
        class="pagination-dot"
        :class="{ active: currentIndex === index }"
        @click="goToSlide(index)"
      ></span>
    </div>
    
    <!-- 左右箭头 -->
    <button class="banner-arrow arrow-left" @click="prevSlide">‹</button>
    <button class="banner-arrow arrow-right" @click="nextSlide">›</button>
  </div>
</template>

<script>
export default {
  name: 'Banner',
  data() {
    return {
      currentIndex: 0,
      bannerList: [
        {
          image: 'https://bank.giftoceanmall.com/2aee8202605261825517586.png',
          path:'/goods_collection_list/13'
        },
        {
          image: 'https://bank.giftoceanmall.com/5da7920260526182607469.png',
          path:'/goods_collection_list/15'
        },
        {
          image: 'https://bank.giftoceanmall.com/387f1202605261826222657.png',
          path:'/goods_collection_list/14'
        }
      ],
      timer: null
    }
  },
  mounted() {
    this.startAutoPlay()
  },
  beforeDestroy() {
    this.stopAutoPlay()
  },
  methods: {
    goTo(item){
      // this.currentIndex = this.bannerList.indexOf(item)
      this.$router.push(item.path)
    },
    startAutoPlay() {
      this.timer = setInterval(() => {
        this.nextSlide()
      }, 4000)
    },
    stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    nextSlide() {
      this.currentIndex = (this.currentIndex + 1) % this.bannerList.length
    },
    prevSlide() {
      this.currentIndex = (this.currentIndex - 1 + this.bannerList.length) % this.bannerList.length
    },
    goToSlide(index) {
      this.currentIndex = index
    }
  }
}
</script>

<style lang="scss" scoped>
.banner-container {
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 0 0 0.3rem 0.3rem;
}

.banner-wrapper {
  position: relative;
  width: 100%;
  height: 5rem;
  overflow: hidden;
}

.banner-track {
  display: flex;
  height: 100%;
  transition: transform 0.5s ease-in-out;
}

.banner-slide {
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.slide-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-pagination {
  position: absolute;
  bottom: 0.3rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.15rem;
  z-index: 3;
}

.pagination-dot {
  width: 0.12rem;
  height: 0.12rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
  
  &.active {
    width: 0.3rem;
    border-radius: 0.06rem;
    background: #fff;
  }
}

.banner-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 0.6rem;
  height: 0.6rem;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 0.35rem;
  cursor: pointer;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease;
  
  &:active {
    background: rgba(255, 255, 255, 0.4);
  }
  
  &.arrow-left {
    left: 0.2rem;
  }
  
  &.arrow-right {
    right: 0.2rem;
  }
}

/* 移动端适配 */
@media screen and (max-width: 480px) {
  .banner-wrapper {
    height: 5rem;
  }
  
  .slide-title {
    font-size: 0.38rem;
  }
  
  .slide-subtitle {
    font-size: 0.24rem;
    margin-bottom: 0.25rem;
  }
  
  .slide-btn {
    padding: 0.15rem 0.35rem;
    font-size: 0.24rem;
  }
  
  .decoration-circle {
    &.circle-1 {
      width: 1.5rem;
      height: 1.5rem;
    }
    
    &.circle-2 {
      width: 1.2rem;
      height: 1.2rem;
    }
    
    &.circle-3 {
      width: 0.8rem;
      height: 0.8rem;
    }
  }
  
  .banner-arrow {
    width: 0.5rem;
    height: 0.5rem;
    font-size: 0.3rem;
  }
}
</style>